/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React from "react";

import chatIcon from "../../../assets/icons/chat.svg";

import * as Styles from './ZendeskButtonStyles';

const ZendeskButton: React.FC = () => {
  return (
    <Styles.ZendeskButton type="button" id="bp-toggle-chat">
      <img src={chatIcon} alt="Chat" />
    </Styles.ZendeskButton>
  )
}

export default ZendeskButton;
